<template>
  <div class="wrapper">
    <div class="box_section">
      <!-- 결제 UI -->
      <div id="payment-method"></div>
      <!-- 이용약관 UI -->
      <div id="agreement"></div>

      <div class="box_wrap">
        <button class="pay_btn" @click="checkInputValid">결제하기</button>
      </div>
    </div>
  </div>
</template>

<script>
import { loadTossPayments } from '@tosspayments/tosspayments-sdk'
import { v4 as uuidv4 } from 'uuid'
import {
  CART_CREATE_PRE_ORDER,
  CART_GET_LIST,
  CART_PRE_ORDER_RESTORE
} from '@/store/types'

export default {
  name: 'TossWidget',
  props: {
    customerName: {
      type: String,
      default: 'customerName'
    },
    orderName: {
      type: String,
      default: ''
    },
    saleAmount: {
      type: Number,
      default: 0,
      required: true
    },
    isGift: {
      type: Boolean,
      default: false
    },
    combinedItemList: {
      type: Array,
      required: true
    },
    mobilePhoneNumber: {
      type: String,
      default: ''
    },
    receiverName: {
      type: String,
      default: ''
    },
    receiverEmail: {
      type: String,
      default: '@'
    },
    discountSelected: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      tossPayments: null,
      widgets: null,
      paymentMethodWidget: null,
      paymentMethod: null,
      agreementWidget: null,
      // TODO: clientKey는 개발자센터의 결제위젯 연동 키 > 클라이언트 키로 바꾸세요.
      // TODO: customerKey는 구매자와 1:1 관계로 무작위한 고유값을 생성하세요.
      clientKey: process.env.VUE_APP_CLIENT_KEY,
      customerKey: `${uuidv4()}`
    }
  },
  async beforeMount() {
    // ------  결제위젯 초기화 ------
    // @docs https://docs.tosspayments.com/reference/widget-sdk#sdk-설치-및-초기화
    this.tossPayments = await loadTossPayments(this.clientKey)
    this.widgets = await this.tossPayments.widgets({
      customerKey: this.customerKey
    })

    this.widgets.setAmount({
      currency: 'KRW',
      value: this.saleAmount
    })

    // ------  결제 UI 렌더링 ------
    // @docs https://docs.tosspayments.com/reference/widget-sdk#renderpaymentmethods선택자-결제-금액-옵션
    this.paymentMethodWidget = await this.widgets.renderPaymentMethods({
      selector: '#payment-method',
      variantKey: 'DEFAULT'
    })
    this.paymentMethod = await this.paymentMethodWidget.getSelectedPaymentMethod()
    this.paymentMethodWidget.on(
      'paymentMethodSelect',
      (selectPaymentMethod) => {
        this.paymentMethod = selectPaymentMethod
      }
    )

    // ------  이용약관 UI 렌더링 ------
    // @docs https://docs.tosspayments.com/reference/widget-sdk#renderagreement선택자-옵션
    this.agreementWidget = await this.widgets.renderAgreement({
      selector: '#agreement',
      variantKey: 'AGREEMENT'
    })
  },
  methods: {
    checkInputValid() {
      if (this.isGift) {
        if (
          this.mobilePhoneNumber == '' ||
          this.receiverName == '' ||
          this.receiverEmail == '@'
        ) {
          this.$emit('validMessage', '모든 정보를 입력해주세요.')
        } else {
          const emailValid = /\S+@\S+\.\S+/
          if (!emailValid.test(this.receiverEmail)) {
            this.$emit('validMessage', '올바른 이메일 형식으로 입력해주세요')
          } else {
            this.requestPayment()
          }
        }
      } else {
        this.requestPayment()
      }
    },
    async requestPayment() {
      try {
        if (this.widgets) {
          // ------ '결제하기' 버튼 누르면 결제창 띄우기 ------
          // 결제를 요청하기 전에 orderId, amount를 서버에 저장하세요.
          // 결제 과정에서 악의적으로 결제 금액이 바뀌는 것을 확인하는 용도입니다.
          this.widgets.setAmount({
            currency: 'KRW',
            value: this.saleAmount
          })
          await this.preOrderSetup()

          // @docs https://docs.tosspayments.com/reference/widget-sdk#requestpayment결제-정보
          await this.widgets.requestPayment({
            orderId: this.customerKey,
            orderName: this.orderName,
            taxFreeAmount: this.saleAmount, // 면세가격
            customerName: this.customerName,
            successUrl: `${window.location.origin}/payment/success`,
            failUrl: `${window.location.origin}/payment/fail`
          })
        }
      } catch (error) {
        try {
          console.log('12456123456')
          const orderData = localStorage.getItem('orderData')
          if (orderData) {
            const order = JSON.parse(orderData) // ✅ JSON 파싱
            const response = await this.$store.dispatch(
              CART_PRE_ORDER_RESTORE,
              order
            )
            console.log(response)
          }
          console.log('af11')
        } catch (innerError) {
          alert(error)
          alert(innerError)
        } finally {
          await this.$store.dispatch(CART_GET_LIST)
          localStorage.removeItem('orderData')
        }
      }
    },
    async preOrderSetup() {
      const order = {
        purchase: {
          orders: {
            procTp: 'PP',
            purchaseTp: this.isGift ? 'GFT' : 'PMT',
            saleAmt: this.saleAmount,
            giftBook: this.isGift
              ? {
                  name: this.receiverName,
                  mobileNo: this.mobilePhoneNumber,
                  email: this.receiverEmail
                }
              : {
                  name: undefined,
                  mobileNo: undefined,
                  email: undefined
                },
            payment: {
              payMethod: this.paymentMethod.code,
              paidAmt: this.saleAmount
              // provider: 'tosspayment',
            },
            selectedCart: [],
            detail: {
              discountSelected: this.discountSelected
            }
          }
        }
      }
      console.log('order')
      console.log(order)
      const formattedCartList = {}

      this.combinedItemList.map((cartItem) => {
        if (!formattedCartList[cartItem.cartCd]) {
          formattedCartList[cartItem.cartCd] = [cartItem.cartGoodsSeq]
        } else {
          formattedCartList[cartItem.cartCd].push(cartItem.cartGoodsSeq)
        }
      })

      Object.keys(formattedCartList).map((key) => {
        order.purchase.orders.selectedCart.push({
          cartCd: key,
          cartGoodsSeqList: formattedCartList[key]
        })
      })
      console.log('order2')
      console.log(order)
      const response = await this.$store.dispatch(CART_CREATE_PRE_ORDER, order)
      order.purchase.orders.payment.applyNum = response.data.result.orderCnt
      order.purchase.orders.payment.merchantId = response.data.result.buyCd
      localStorage.setItem('orderData', JSON.stringify(order))
      if (this.isGift) {
        const giftData = {
          name: this.receiverName,
          email: this.receiverEmail,
          mobileNo: this.mobilePhoneNumber
        }
        localStorage.setItem('giftData', JSON.stringify(giftData))
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.payment-widget-cache-1ib4csb {
  padding: 0;
}
.box_wrap {
  text-align: center;
}
.pay_btn {
  width: 30%;
  height: 56px;
  background-color: #006fb9;
  border-radius: 7px;
  letter-spacing: 0.6px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}
@media (max-width: 480px) {
  .pay_btn {
    width: 90%;
    height: 50px;
    font-size: 15px;
  }
}
</style>
